import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import IconPlay from '@/components/icons/videoplayer/Play.vue';
import IconPause from '@/components/icons/videoplayer/Pause.vue';

const cssClass = 'videoplayer';

export default /*#__PURE__*/_defineComponent({
  __name: 'Play',
  props: {
    isPaused: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(`${cssClass}__btn`),
    "aria-label": _ctx.isPaused ? 'Пуск' : 'Пауза',
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    (_ctx.isPaused)
      ? (_openBlock(), _createBlock(IconPlay, { key: 0 }))
      : (_openBlock(), _createBlock(IconPause, { key: 1 }))
  ], 10, _hoisted_1))
}
}

})